import React from 'react';
import { CheckCircle, AlertTriangle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../components/ui/alert-dialog';
import { toast } from 'sonner';

/**
 * Diálogo para mostrar resultados de carga masiva
 */
const BulkUploadResultsDialog = ({
  open,
  onClose,
  samplesCreated,
  errors = [],
}) => {
  const hasErrors = errors.length > 0;

  const handleCopyErrors = () => {
    const text = errors.join('\n');
    navigator.clipboard.writeText(text);
    toast.success('Errores copiados al portapapeles');
  };

  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <AlertDialogContent className="max-w-lg max-h-[80vh] overflow-hidden flex flex-col" data-testid="bulk-upload-results-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            {hasErrors ? (
              <AlertTriangle className="text-amber-500" size={20} />
            ) : (
              <CheckCircle className="text-green-500" size={20} />
            )}
            Resultados de la Carga Masiva
          </AlertDialogTitle>
        </AlertDialogHeader>
        
        <div className="space-y-4 overflow-y-auto flex-1">
          {/* Summary */}
          <div className="flex gap-4 justify-center">
            <div className="bg-green-50 p-4 rounded-lg text-center flex-1">
              <p className="text-3xl font-bold text-green-600">{samplesCreated}</p>
              <p className="text-sm text-green-700">Muestras creadas</p>
            </div>
            {hasErrors && (
              <div className="bg-amber-50 p-4 rounded-lg text-center flex-1">
                <p className="text-3xl font-bold text-amber-600">{errors.length}</p>
                <p className="text-sm text-amber-700">Errores</p>
              </div>
            )}
          </div>

          {/* Errors Section */}
          {hasErrors && (
            <div className="border-t pt-4">
              <div className="flex items-center justify-between mb-2">
                <h4 className="font-semibold text-amber-700 flex items-center gap-2">
                  <AlertTriangle size={16} />
                  Errores encontrados
                </h4>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={handleCopyErrors}
                  data-testid="copy-errors-btn"
                >
                  Copiar errores
                </Button>
              </div>
              <div className="max-h-60 overflow-y-auto bg-amber-50 p-3 rounded border border-amber-200">
                <ul className="text-sm space-y-2">
                  {errors.map((error, idx) => (
                    <li key={idx} className="text-amber-800 py-2 border-b border-amber-100 last:border-0">
                      <span className="font-medium text-amber-900">Fila {idx + 1}:</span> {error}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>

        <AlertDialogFooter className="mt-4">
          <AlertDialogAction onClick={onClose} data-testid="bulk-upload-close-btn">
            Cerrar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default BulkUploadResultsDialog;
